// Mock data pour MMD CONSEIL

export const mockData = {
  cabinet: {
    nom: "MMD CONSEIL",
    slogan: "Votre partenaire de confiance pour piloter et développer votre entreprise à Lyon",
    description: "Cabinet d'expertise comptable et de conseil accompagnant les entrepreneurs, PME et indépendants dans leur développement.",
    bureaux: [
      {
        id: "lyon",
        nom: "Bureau de Lyon",
        pays: "France",
        adresse: "220 Avenue Victor Hugo, 69140 Rillieux-la-Pape",
        telephone: "04 82 53 06 84",
        email: "contact@mmd-conseils.fr",
        whatsapp: "33667308894",
        googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=220+Avenue+Victor+Hugo,+69140+Rillieux-la-Pape",
        horaires: {
          semaine: "Lundi - Vendredi : 9h00 - 17h00",
          samedi: "Sur rendez-vous",
          dimanche: "Fermé"
        }
      }
    ],
    // Rétrocompatibilité - bureau principal (Lyon)
    adresse: "220 Avenue Victor Hugo, 69140 Rillieux-la-Pape",
    telephone: "04 82 53 06 84",
    email: "contact@mmd-conseils.fr",
    whatsapp: "33667308894"
  },

  fondateur: {
    nom: "Makhan DIALLO",
    titre: "Expert-Comptable Diplômé",
    bio: "Diplômé du DEC (Diplôme d'Expertise Comptable), Makhan DIALLO cumule plus de 10 ans d'expérience dans l'expertise comptable. Ayant exercé dans des cabinets prestigieux et développé une solide expertise en révision comptable, audit et gestion de portefeuilles clients diversifiés (TPE, PME, fonds d'investissement), il a fondé MMD CONSEIL pour offrir un accompagnement personnalisé et de proximité aux entrepreneurs de la région lyonnaise.",
    experience: "10+ ans d'expérience",
    diplomes: "DEC - Diplôme d'Expertise Comptable"
  },

  valeurs: [
    {
      titre: "Excellence",
      description: "Nous garantissons un service de qualité supérieure, rigoureux et personnalisé pour chaque client.",
      icon: "Award"
    },
    {
      titre: "Discipline",
      description: "Respect des délais, conformité réglementaire et suivi méticuleux de vos obligations comptables et fiscales.",
      icon: "Clock"
    },
    {
      titre: "Humilité",
      description: "À votre écoute, nous restons disponibles et accessibles pour vous accompagner en toute simplicité.",
      icon: "Heart"
    }
  ],

  services: [
    {
      id: 1,
      titre: "Expertise Comptable & Fiscalité",
      description: "Tenue complète de votre comptabilité, optimisation fiscale, et accompagnement dans toutes vos obligations comptables et fiscales.",
      details: [
        "Saisie et contrôle des écritures comptables",
        "Révision des comptes et ajustements",
        "Établissement des bilans annuels",
        "Comptes de résultat détaillés",
        "Liasses fiscales",
        "Déclarations de TVA",
        "Impôt sur les sociétés",
        "Optimisation fiscale personnalisée",
        "Conseils en restructuration",
        "Gestion des contrôles fiscaux"
      ],
      icon: "Calculator"
    },
    {
      id: 2,
      titre: "Social & Paie",
      description: "Gestion complète de la paie, déclarations sociales, et conseils en droit social pour vos équipes.",
      details: [
        "Établissement des bulletins de paie",
        "Déclarations sociales (DSN)",
        "Conseils en droit du travail",
        "Gestion des contrats de travail",
        "Suivi des congés et absences"
      ],
      icon: "Users"
    },
    {
      id: 3,
      titre: "Conseil & Accompagnement",
      description: "Conseil stratégique, aide à la création d'entreprise, et accompagnement dans vos projets de développement.",
      details: [
        "Conseil en création d'entreprise",
        "Business plan et prévisionnels",
        "Accompagnement stratégique",
        "Gestion de trésorerie",
        "Cession et transmission d'entreprise"
      ],
      icon: "TrendingUp"
    },
    {
      id: 4,
      titre: "Stratégie de Rémunération",
      description: "Optimisation de votre rémunération dirigeant pour maximiser votre revenu net après impôts et cotisations.",
      details: [
        "Analyse de votre structure de rémunération actuelle",
        "Optimisation fiscale et sociale personnalisée",
        "Étude comparative des statuts (salarié, TNS, dividendes)",
        "Création de structures dédiées si nécessaire",
        "Accompagnement juridique complet",
        "Prise en compte des droits à la retraite",
        "Mise en place et suivi des solutions retenues"
      ],
      icon: "TrendingUp",
      specialty: true,
      benefits: [
        "Gain potentiel jusqu'à 6% sur votre revenu net",
        "Optimisation en conformité totale avec la législation",
        "Approche sur mesure selon votre situation",
        "Prise en compte de vos droits futurs",
        "Accompagnement de A à Z dans la mise en place"
      ],
      pricing: {
        description: "Mission complémentaire spécialisée",
        note: "Tarification adaptée selon la complexité et les gains potentiels"
      }
    },
    {
      id: 5,
      titre: "Pôle – Expertise auprès des CSE",
      description: "Mandat auprès des Comités Sociaux et Économiques (CSE) pour auditer la stratégie de l'entreprise, diagnostiquer sa situation économique et sécuriser les procédures sociales.",
      details: [
        "Audit de la stratégie de l'entreprise",
        "Diagnostic de la situation économique et financière et de la politique sociale",
        "Conseil social et sécurisation des PSE (Plans de Sauvegarde de l'Emploi)"
      ],
      icon: "ShieldCheck"
    },
    {
      id: 6,
      titre: "Pôle – Stratégie corporate & board advisory",
      description: "Conseil en stratégie d'entreprise et accompagnement des dirigeants dans le pilotage de leurs projets stratégiques et l'animation de leurs instances de gouvernance.",
      details: [
        "Conseil en stratégie d'entreprise",
        "Élaboration et pilotage de projet stratégique d'entreprise",
        "Création et/ou animation de CoDir (Independant Board Member)"
      ],
      icon: "Briefcase"
    }
  ],

  actualites: [
    {
      id: 1,
      titre: "Loi de Finances 2025 : Les mesures qui impactent les PME",
      resume: "Analyse des principales dispositions fiscales de la Loi de Finances 2025 et leur impact concret sur la gestion des PME françaises.",
      contenu: "La Loi de Finances 2025 apporte son lot de nouveautés pour les entreprises. Parmi les mesures phares : la revalorisation du barème de l'impôt sur les sociétés pour les PME, l'extension du crédit d'impôt recherche aux PME innovantes, et la simplification des obligations déclaratives. Ces évolutions nécessitent une adaptation de votre stratégie fiscale. Notre cabinet MMD CONSEIL vous accompagne dans l'analyse de ces impacts et l'optimisation de votre situation fiscale. N'hésitez pas à nous consulter pour une étude personnalisée de votre dossier.",
      datePublication: "2025-09-15",
      auteur: "MMD CONSEIL",
      categorie: "Fiscalité",
      source: "Analyse MMD CONSEIL d'après les textes officiels"
    },
    {
      id: 2,
      titre: "Facturation électronique obligatoire : Êtes-vous prêt pour 2026 ?",
      resume: "Point sur l'obligation de facturation électronique B2B qui entrera en vigueur progressivement. Préparez dès maintenant votre transition.",
      contenu: "L'obligation de facturation électronique entre entreprises sera effective dès septembre 2026 pour les grandes entreprises, puis étendue aux PME en 2027. Cette réforme majeure impose l'utilisation de factures au format électronique structuré et leur transmission via des plateformes certifiées. Les enjeux sont multiples : adaptation des systèmes informatiques, formation des équipes, choix des partenaires technologiques. Chez MMD CONSEIL, nous anticipons ces changements avec nos clients pour une transition sereine. Contactez-nous pour évaluer votre niveau de préparation.",
      datePublication: "2025-08-28",
      auteur: "Makhan DIALLO",
      categorie: "Réglementation",
      source: "Analyse MMD CONSEIL d'après la DGFiP"
    },
    {
      id: 3,
      titre: "Intelligence Artificielle en comptabilité : Opportunités et vigilance",
      resume: "Comment l'IA transforme la profession comptable tout en préservant l'expertise humaine. Guide pratique pour les dirigeants.",
      contenu: "L'intelligence artificielle révolutionne progressivement la comptabilité : automatisation de la saisie, détection d'anomalies, génération de reportings prédictifs. Pour les PME, ces outils représentent une opportunité d'optimiser leurs processus tout en réduisant les coûts. Cependant, l'expertise humaine reste irremplaçable pour l'interprétation, le conseil stratégique et la prise de décision. Chez MMD CONSEIL, nous intégrons progressivement ces technologies pour améliorer notre service tout en conservant notre accompagnement personnalisé. L'avenir de la comptabilité combine efficacité technologique et conseil humain de qualité.",
      datePublication: "2025-08-12",
      auteur: "Makhan DIALLO",
      categorie: "Digital",
      source: "Analyse MMD CONSEIL - Veille technologique"
    },
    {
      id: 4,
      titre: "TVA : Nouvelles règles d'exigibilité pour le e-commerce",
      resume: "Les évolutions réglementaires TVA pour les plateformes de e-commerce et leurs implications pour les vendeurs en ligne.",
      contenu: "Le commerce électronique connaît des évolutions réglementaires majeures en matière de TVA. Les plateformes digitales sont désormais considérées comme redevables de la TVA pour certaines ventes, particulièrement pour les biens vendus par des tiers établis hors UE. Ces changements impactent directement les e-commerçants français qui doivent adapter leurs déclarations et leur comptabilité. Les obligations déclaratives évoluent également avec de nouveaux formulaires et délais. Notre expertise chez MMD CONSEIL nous permet d'accompagner les entreprises du digital dans cette transition réglementaire complexe.",
      datePublication: "2025-07-30",
      auteur: "Makhan DIALLO",
      categorie: "Fiscalité",
      source: "Analyse MMD CONSEIL d'après les directives européennes"
    },
    {
      id: 5,
      titre: "Bilan carbone obligatoire : Impact comptable et fiscal",
      resume: "Les nouvelles obligations environnementales et leur traduction comptable. Guide pratique pour les PME concernées.",
      contenu: "L'extension progressive de l'obligation de bilan carbone aux PME s'accompagne d'enjeux comptables et fiscaux spécifiques. Les investissements verts bénéficient d'avantages fiscaux renforcés, tandis que de nouveaux postes comptables émergent pour tracer les dépenses environnementales. Les entreprises doivent également provisionner certains risques climatiques. Cette transition écologique nécessite une adaptation de l'organisation comptable et une veille réglementaire constante. MMD CONSEIL accompagne ses clients dans cette démarche environnementale en intégrant ces aspects dans leur gestion comptable quotidienne.",
      datePublication: "2025-07-18",
      auteur: "Makhan DIALLO",
      categorie: "Réglementation",
      source: "Analyse MMD CONSEIL d'après l'ADEME"
    }
  ],

  temoignages: [
    {
      nom: "Léo Rouiller",
      entreprise: "Restaurant Le Bouchon Lyonnais",
      avis: "Depuis que nous avons fait appel à MMD CONSEIL, nous bénéficions d'un accompagnement de qualité. Leur réactivité et leur expertise nous permettent de nous concentrer sur notre métier en toute sérénité.",
      note: 5
    },
    {
      nom: "Mohamed Dahman",
      entreprise: "Martin Électricité",
      avis: "Un cabinet à l'écoute, des conseils pertinents et un suivi de proximité. Je recommande vivement MMD CONSEIL à tous les entrepreneurs qui cherchent un expert-comptable fiable.",
      note: 5
    },
    {
      nom: "Amélie Dubois",
      entreprise: "Atelier Créatif AR",
      avis: "Grâce aux conseils de Makhan DIALLO, j'ai pu optimiser ma fiscalité et développer mon entreprise. Un accompagnement sur mesure et des conseils très professionnels !",
      note: 5
    }
  ]
};